<template>
  <div class="card-section">
    <v-container class="details-panel mt-5">
      <v-row class="details-panel__row">
        <v-chip class="mr-5" label :color="websiteStatusChipColor" small>{{
          websiteStatusText
        }}</v-chip>
        <span class="go-live">Live: {{ formattedGoLiveDate }}</span>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// vuex
// library
// internal
// components
export default {
  name: 'DetailsPanel',
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  data() {
    return {}
  },
  computed: {
    acf() {
      return this.data.acf_data
    },
    formattedGoLiveDate() {
      return this.acf['go-live_date']
    },
    websiteStatusText() {
      switch (this.data.post_status) {
        case 'publish':
          return 'Public'
        case 'private':
          return 'Private'
        default:
          return this.data.post_status
      }
    },
    websiteStatusChipColor() {
      switch (this.data.post_status) {
        case 'publish':
          return 'success'
        case 'draft':
          return '#FF9800'
        default:
          return 'error'
      }
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.details-panel {
  padding: 0px;

  .go-live {
    color: #666666;
  }
}
</style>
